import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskRequestTypesWorkCategoryRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-request-types-work-category',
	path: '/jira/servicedesk/projects/:projectKey/settings/request-types/category/:practice',
	exact: true,
};
